// extracted by mini-css-extract-plugin
module.exports = {"search":"Search_search__TvmyU","table":"Search_table__iH2_H","results":"Search_results__PdV5m"};